import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetUserStatisticsDto, queryKeys, useAccessToken } from "src/http";

const useGetUserStatisticsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getUserStatisticsRequest({
    queryKey,
    signal,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.users.getUserStatistics>>): Promise<GetUserStatisticsDto> {
    const [{ userId }] = queryKey;
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/users/${userId}/statistics`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      signal,
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getUserStatisticsRequest };
};

const useGetUserStatistics = (userId: string | undefined) => {
  const { getUserStatisticsRequest } = useGetUserStatisticsRequest();

  return useQuery({
    queryKey: queryKeys.users.getUserStatistics(userId),
    queryFn: getUserStatisticsRequest,
    cacheTime: 0,
  });
};

export { useGetUserStatistics };
